import SettingsContent from '../Wrapper.vue';
import Index from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/schoolContracts'),
      roles: ['administrator'],
      component: SettingsContent,
      props: {
        headerTitle: 'SCHOOL_CONTRACT_SETTINGS.HEADER',
        icon: 'book-contacts',
        showNewButton: true,
      },
      children: [
        {
          path: '',
          name: 'school_contracts_wrapper',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'school_contracts_list',
          component: Index,
          roles: ['administrator'],
        },
      ],
    },
  ],
};
